import { useEffect, useState, useCallback } from "react";
import {getClientsV2, GetClientsV2Table } from "../../data/accountsData";
import { Drawer, DrawerContent, DrawerNavigation } from "@progress/kendo-react-layout";
import { FaTimesCircle } from "react-icons/fa";
import AccountsGrid from "../../components/grids/AccountsGrid";
import AccountForm from "../../components/FormComps/Accounts/AccountForm";
import { canEditArea } from "../../helpers/areaAccess";


interface AccountsProps {
  allowedRoutes?: string[];
}

export default function Accounts(props: AccountsProps) {
  // Accounts.View only looks; Accounts.Edit or an administrator change. Only restore is enforced on the server: the
  // account, address and contact writes are shared with Jobs, Quotes etc.
  const canEdit = canEditArea(props.allowedRoutes, "Accounts");

  const [expanded, setExpanded] = useState(false);
  const [selectedId, setSelectedId] = useState<number>(0);
  const [formVisible, setFormVisible] = useState(false);
  const [mode, setMode] = useState<"edit" | "add">("edit");
  const [showDeleted, setShowDeleted] = useState(false);
  
  // Wrap setShowDeleted to add logging
  const handleShowDeletedChange = (value: boolean) => {
    console.log('🎯 Parent setShowDeleted called with:', value);
    setShowDeleted(value);
  };


  /**
   * State to hold accounts for the table view
   */
  const [accounts, setAccounts] = useState<GetClientsV2Table[]>([]);
  
  console.log('🏠 Accounts RENDER - showDeleted:', showDeleted, 'accounts length:', accounts.length);

  /**
   * Fetches the accounts data and updates the state with the retrieved data.
   * If an error occurs during the fetch, it logs the error to the console.
   * Wrapped in useCallback to ensure it always uses current showDeleted value.
   *
   * @async
   * @function getAccountsTable
   * @returns {Promise<void>} A promise that resolves when the accounts data is fetched and state is updated.
   */
  const getAccountsTable = useCallback(async () => {
    try {
      console.log('🔍 Parent fetching accounts with showDeleted:', showDeleted);
      const res = await getClientsV2(showDeleted)
      console.log('📦 Parent received', res.length, 'accounts');
      setAccounts(res);
    } catch (err) {
      console.log(err)
    }
  }, [showDeleted]);

  /**
   * Toggles the expanded state of the component.
   */
  const handleExpanded = () => {
    setExpanded((prevState) => {
      if (prevState) {
        // Clear form state when closing the sidebar
        setSelectedId(0);
        setFormVisible(false);
        setMode("edit");
      }
      return !prevState;
    });
  };

  /**
   * Handles the edit form for a specific ID.
   * 
   * @param id - The ID of the item to be edited.
   */
  const handleEditForm = (id: number) => {
    setSelectedId(id);
    setFormVisible((prevState) => (!prevState ? true : true));
    setMode("edit");
    handleExpanded();
  };

  /**
   * Handles the selection event.
   * Sets the expanded state to false.
   */
  const handleSelect = () => {
    setExpanded(false);
  };

  /**
   * Handles the action of adding a form.
   */
  const handleAddForm = () => {
    setFormVisible((prevState) => (!prevState ? true : true));
    setMode('add')
    handleExpanded();
  };


  /**
   * Fetch accounts data whenever showDeleted state changes
   */
  useEffect(() => {
    console.log('🎯 Parent showDeleted changed:', showDeleted);
    getAccountsTable();
  }, [showDeleted, getAccountsTable]);

  return (
    <div>
      <Drawer
        expanded={expanded}
        position={"end"}
        width={750}
        mode="overlay"
        animation={{
          duration: 400,
        }}
        onOverlayClick={handleExpanded}
        onSelect={handleSelect}
      >
        <DrawerContent>
          <DrawerNavigation>
            {formVisible && (
              <>
                <div className="form__title__container">
                  <h1 className="form__title">{mode === "edit" ? (canEdit ? "Edit Account" : "Account") : "Add New Account"}</h1>
                  <FaTimesCircle
                    className="closeform"
                    onClick={handleExpanded}
                  />
                </div>
                <AccountForm
                  id={selectedId}
                  mode={mode}
                  getTableData={getAccountsTable}
                  handleExpanded={handleExpanded}
                  readOnly={!canEdit}
                />

              </>
            )}
          </DrawerNavigation>

          <AccountsGrid
            onAddToggle={handleAddForm}
            onEditToggle={handleEditForm}
            onData={accounts}
          // onExportData={enquiryExportData}
            onShowDead={handleShowDeletedChange}
            showDeleted={showDeleted}
            onRefresh={getAccountsTable}
            canEdit={canEdit}
          //   onShowProgressed={showCompleted}
          />
        </DrawerContent>
      </Drawer>
      {/* {visibleClientModal && (
              <Dialog
                width={500}
                height={700}
                title={'Please confirm'}
                onClose={() => toggleModal('client')}
              >
                <AddClientForm onClientSubmit={newClientHandler} />
              </Dialog>
            )}
            {visibleSiteModal && (
              <Dialog
                width={500}
                height={700}
                title={'Please confirm'}
                onClose={() => toggleModal('site')}
              >
                <AddSiteForm onSiteSubmit={newSiteHandler} />
              </Dialog>
            )}       */}
    </div>
  )
}